import { Deposit, Withdraw } from '../../../../../../models';

export enum StepperOptions {
  Created,
  Processing,
  Result,
}

export interface TransactionModalResponseContentStepperStepProps {
  position?: StepperOptions;
  transaction?: Deposit | Withdraw;
}
